'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';

import { defiYieldsOverviewBunja } from '../shared/state';
import { Hero } from './section/1-hero';
import { Overview } from './section/2-overview';
import { Earnings } from './section/3-earnings';
import { Learn } from './section/4-learn';
import { Faq } from './section/5-faq';

export const DynamicEarnPage = () => {
  const { showOverviewAtom } = useBunja(defiYieldsOverviewBunja);
  const showOverview = useAtomValue(showOverviewAtom);

  return (
    <main className={css({ maxW: 'desktopMaxWidth', mx: { base: 16, smallDesktop: 'auto' }, pb: 130 })}>
      <Hero />
      {showOverview && <Overview />}
      <Earnings />
      <Learn />
      <Faq />
    </main>
  );
};
